import { render, staticRenderFns } from "./SummaryBoxText.vue?vue&type=template&id=eac8e66c&scoped=true&"
import script from "./SummaryBoxText.vue?vue&type=script&lang=js&"
export * from "./SummaryBoxText.vue?vue&type=script&lang=js&"
import style0 from "./SummaryBoxText.vue?vue&type=style&index=0&id=eac8e66c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eac8e66c",
  null
  
)

export default component.exports